import {useEffect, useRef} from "react";
import Api from "../../fetchs/Api";
import Modals from "../../componentesHTML/componentesSecundarios/Modals";
import {useStoreGlobal} from '../../../stores/Global'
import {useShallow} from 'zustand/react/shallow'
import Highlighter from "react-highlight-words"
import ApiInsertarBusquedaClic from "../../fetchs/ApiInsertarBusquedaClic";
import latinize from 'latinize';
import ApiInsertarBusqueda from "../../fetchs/ApiInsertarBusqueda";
function BuscadorPublicaciones(parametros){
  const _updateTotalDatos= useStoreGlobal(useShallow((state) => state._updateTotalDatos));
  const descripcionRef= useRef([]);
  let var_ingles = "es";
  if (window.location.href.indexOf("en.") > -1) {
      var_ingles = "en";
  }
  let apiData = "";
  function fecha(fecha){
    let fec = fecha.split("T");
    return fec[0];
  }
  let idioma = var_ingles==="es"?"Fecha de última actualización:":"Date for last update:";
  const registradatos = ((TITULO,URL,metodoBusqueda) => {
    TITULO= TITULO.replace(/['°|@_=¿?¡!:/<>()&~%#*;+-.,?^${}[(\)]|[\]\\]/g, " ");
      let metodo="";
      if (metodoBusqueda === 1){
        metodo="Todas las palabras";
      }
      if (metodoBusqueda === 2){
        metodo="Cualquier palabra";
      }
      if (metodoBusqueda === 3){
        metodo="Frase completa";
      }
      const param = {
        CONTADOR_CLICK: 1,
        ID_COLECCION: "5",
        IP_USER: "",
        Metodo: metodo,
        Palabra_relacionada: "",
        TEXTO_BUSCADO: parametros.textoBusqueda,
        TITULO_URL: TITULO.replace(/['°|@_=¿?¡!~:/<>()&%#*;+-.,?^${}[(\)]|[\]\\]/g, " "),
        URL: URL
      };
    ApiInsertarBusquedaClic(param);
  });
  const highlightTexto = (textoSuggest) => {
        let campo = document.getElementById('inputQ').value.trim();
        campo= campo.replace(/['°|@_=¿?¡!:/~<>()&%#*;+-.,?^${}[(\)]|[\]\\]/g, " ");
        campo= trataTextoHigh(campo);
        let textInputAux = campo.split(" ");
        let concatena= [];
        for (const word of textInputAux) {
          concatena.push(`${word}`); 
        }
        return  (
            <Highlighter
                    highlightClassName="highlight"
                    searchWords={concatena}
                    autoEscape={true}
                    textToHighlight= {textoSuggest}
                    sanitize={sanitizeText}
                /> 
        );
    }
    const sanitizeText = (text) => {
      return latinize(text);
    };
    function trataTextoHigh(texto) { 
    let articulos = [
        "insert", "drop", "delete", "truncate", ";", "--", "xp_", "in", "table", "exec", "of", "with", "the", "from", "al", "as", "is", "can", " also ", " already ", " more ", " you ", " others ", " and ", " but ", " between ", " are ", " than ", "one", "no", "your", "it",
        "a", "e", "i", "o", "u", "adónde", "al", "algo", "alguien", "alguna", "algunas", "alguno", "algunos", "ante", "aquel", "aquél",
        "aquella", "aquélla", "aquellas", "aquéllas", "aquello", "aquellos", "aquéllos", "bajo", "cabe",
        "como", "cómo", "con", "conmigo", "consigo", "contigo", "contra", "cual", "cuál", "cuales", "cuáles",
        "cualesquiera", "cualquiera", "cuando", "cuándo", "cuanta", "cuánta", "cuantas", "cuántas", "cuánto",
        "cuantos", "cuántos", "cuya", "cuyas", "cuyo", "cuyos", "de", "del", "demás", "desde", "donde", "dónde",
        "durante", "el", "él", "ella", "ellas", "ello", "ellos", "en", "entre", "es", "esa", "ésa", "esas", "ésas", "ese",
        "ése", "eso", "esos", "ésos", "esotra", "esotro", "esta", "está", "ésta", "estas", "éstas", "este", "éste",
        "esto", "estos", "éstos", "hacia", "hasta", "la", "las", "le", "les", "lo", "los", "más", "me", "mediante",
        "mí", "mía", "mías", "mío", "míos", "misma", "mismas", "mismo", "mismos", "mucha", "muchas", "mucho",
        "muchos", "nada", "nadie", "ninguna", "ningunas", "ninguno", "ningunos", "no", "nos", "nosotras",
        "nosotros", "nuestra", "nuestras", "nuestro", "nuestros", "os", "otra", "otras", "otro", "otros",
        "para", "pero", "poca", "pocas", "poco", "pocos", "por", "puede", "que", "qué", "quien", "quién", "quienes", "quiénes",
        "se", "según", "sí", "sin", "so", "sobre", "son", "su", "suya", "suyas", "suyo", "suyos", "también", "tanta",
        "tantas", "tanto", "tantos", "te", "ti", "toda", "todas", "todo", "todos", "tras", "tú", "tuya", "tuyas", "tuyo",
        "tuyos", "última", "últimas", "último", "últimos", "un", "una", "unas", "uno", "unos", "usted", "ustedes", "varias",
        "varios", "versus", "vía", "vos", "vosotras", "vosotros", "vuestra", "vuestras", "vuestro", "vuestros", "y", "ya", "yo"
    ];
    let parrafo = (texto.replace(/\./g, '').trim());
    let palabras = parrafo.split(/\s/);
    for (let p = 0; p < palabras.length; p++) {
        for (let a = 0; a < articulos.length; a++) {
            if (articulos[a] == palabras[p].toLowerCase()) {
                palabras[p] = '';
                break;
            }
        }
    }
    let newTexto = palabras.join(' ');
    let textoTratado = newTexto.replace(/([\ \t]+(?=[\ \t])|^\s+|\s+$)/g, '');
    return textoTratado;
    }
  if (parametros.coleccionTodo != "Todo") {
    let metodo="";
      if (parametros.metodoBusqueda === 1){
        metodo="Todas las palabras";
      }
      if (parametros.metodoBusqueda === 2){
        metodo="Cualquier palabra";
      }
      if (parametros.metodoBusqueda === 3){
        metodo="Frase completa";
      }
    const param = {
      busqueda: parametros.textoBusqueda,
      busquedaCiencia: "",
      paginaInicio: parametros.pageInicial,
      paginaFin: parametros.pageFin,
      filtroAreaGeo: "",
      filtrobusqueda: parametros.camposBuscador,
      orderby: parametros.camposOrden,
      orderbyAscDesc: parametros.ordenamiento,
      metodoBusqueda: parametros.metodoBusqueda
    };
    apiData = Api("/app/api/buscadorcore/v1/busquedaPublicaciones/", param)
    function RegistraBus(data){
          if(data.length > 0)
            ApiInsertarBusqueda(parametros.textoBusqueda ,"5", data[0].TOTAL, metodo);
          else
            ApiInsertarBusqueda(parametros.textoBusqueda ,"5", 0, metodo);
        }
    useEffect(() => {
    let tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
      let tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new bootstrap.Tooltip(tooltipTriggerEl)
      }) 
      if (!apiData.loading){
        RegistraBus(apiData.data)
      }
      if(parametros.coleccionTodo != "Todo"){
        if(apiData.data.length > 0) {
          apiData.data.forEach(element => {
            if (descripcionRef.current[element.ID] != null ) {
              document.getElementById("nivel2-6-0-" + element.ID).innerHTML=element.DESCRIPCION;
            }
          });
          document.getElementById('resultados').innerHTML= apiData.data[0].TOTAL;
          _updateTotalDatos({totalDatos:apiData.data[0].TOTAL});
        }else{
          _updateTotalDatos({totalDatos:0});
          document.getElementById('resultados').innerHTML= 0;
        }
      } 
    },[apiData.data]);
    return(
        <>
        {apiData.loading? <Modals />:
          !apiData.loading && apiData.data.map((datos,i) => (
          <div className = "col-xs-12 col-sm-12 todo" key={"coleccionBuscadorPublicaciones-" + i} style={{marginBottom:"26px"}} id={"resultadoGeneral-" + i}>
            <div  style={{paddingLeft: "0px"}} id={"titulo-" + i}>
              <a target="_blank" href={"/app/biblioteca/ficha.html?upc=" + datos.UPC} id={"TituloHiper-0" + i}>
                <span id={"gadget-" + i} onClick={() =>registradatos(datos.TITULO, "/app/biblioteca/ficha.html?upc=" + datos.UPC,parametros.metodoBusqueda)}> 
                  {highlightTexto(datos.TITULO)} 
                </span>
              </a>
            </div>
            <div className="row" id={"row-" + i}>
              <div className="col-xs-12 col-md-3 col-sm-5" id={"nivel1-" + i}>
                <div className="img-prod-map" id={"nivel1-1-" + i}>
                  <a target="_blank" href={"/app/biblioteca/ficha.html?upc=" + datos.UPC} id={"snippet_row-tag-a-" + i} onClick={() =>registradatos(datos.TITULO,"/app/biblioteca/ficha.html?upc=" + datos.UPC,parametros.metodoBusqueda)}>
                    <img src={"/contenidos/productos/prod_serv/contenidos/espanol/bvinegi/productos/img/" + datos.IMAGEN + ".jpg"} className="img-responsive i-sombra i-tamano" id={"imagen-" + i } alt="" />
                  </a>
                </div>
              </div>
              <div className="col-xs-12 col-md-9 col-sm-7" id={"nivel2-" + i}>
                <div id={"nivel2-0-" + i}>
                  <div className="row" id={"nivel2-0-1-" + i}>
                    <div className="col-md-3" id={"nivel2-0-1-" + i}><b> {var_ingles === "es"? "Entidad federativa:" : "Federal entity:"}</b>
                      </div>
                      <div className="col-md-6" id={"nivel2-0-2-" + i}>
                        {datos.DESC_ENTIDAD}
                    </div>
                  </div>
                  <div className="row" id={"nivel2-0-2-" + i} >
                    <div className="col-md-3" id={"nivel2-2-" + i}><b> {var_ingles === "es"? "Edición:" : "Edition:"}</b>
                      </div>
                      <div className="col-md-6" id={"nivel2-2-0-" + i}>
                        {datos.EDICION}
                    </div>
                  </div>
                  <div className="row" id={"nivel2-0-3-" + i} >
                    <div className="col-md-3" id={"nivel2-3-" + i}><b> {var_ingles === "es"? "Temporalidad:" : "Temporality:"}</b>
                      </div>
                      <div className="col-md-6" id={"nivel2-3-0-" + i}>
                        {datos.TEMPORALIDAD}
                    </div>
                  </div>
                  <div className="row" id={"nivel2-0-4-" + i} >
                    <div className="col-md-3" id={"nivel2-4-" + i}><b> {var_ingles === "es"? "Desglose geográfico:" : "Geographical breakdown:"}</b>
                      </div>
                      <div className="col-md-6" id={"nivel2-4-0-" + i}>
                        {datos.COBERTURA}
                    </div>
                  </div>
                  {
                        datos.ISBN !==""? 
                        <div className="row" id={"nivel2-0-5-" + i} >
                          <div className="col-md-3" id={"nivel2-5-" + i}><b> {"ISBN:"}</b>
                            </div>
                            <div className="col-md-9" style={{textAlign:"justify"}} id={"nivel2-5-0-" + i}>
                              {datos.ISBN}
                          </div>
                        </div>
                      :"" 
                  }
                  {
                        datos.DESCRIPCION !==""? 
                        <div className="row" id={"nivel2-0-6-" + i} >
                          <div className="col-md-3" id={"nivel2-6-" + i}><b> {var_ingles === "es"? "Descripción:" : "Description:"}</b>
                          </div>
                          <div className="col-md-8"  ref={(el) => (descripcionRef.current[i] = el)} style={{textAlign:"justify"}} id={"nivel2-6-0-" + i}>
                          </div>
                        </div>
                      :"" 
                  }
                  <div className="row" id={"nivel2-0-7-" + i} >
                    <div className="col-md-3" id={"nivel2-0-7-1-" + i}><b>{var_ingles==="es"? "Formatos" : "Formats"}</b>
                      <a className="inegi-info bbl-no-link_buscador" target="_blank" href="/inegi/ayuda/formatos/publicaciones.html" 
                      data-tooltip-id="BotonAyuda" id={"snippet_row-tag_publicacion_a-" + datos.ID}
                      data-bs-toggle="tooltip"
                      data-bs-placement="bottom"
                      title={var_ingles==="es"? "Ayuda de formatos disponibles": "Help available formats"} 
                      >
                      </a>
                      <b>:</b>
                    </div>
                    <div className="col-md-6" style={{textAlign:"justify"}} id={"nivel2-0-7-2-" + i}>
                      {
                        datos.URL_PDF !==""? 
                        <>
                          <div className="col-md-1 col-xs-12" style={{marginRight:"10px"}} id={"nivel1-pdf-" + i}>
                            <a target="_blank" href={"https://www.inegi.org.mx/contenidos/productos" + datos.URL_PDF} id={"nivel1-pdf-1-" + i}>
                              <img src="/img/ico/ico_pdf.png" className="img-responsive tag-center" alt=""/>
                            </a>
                          </div>
                          <div className="col-xs-12 col-12" id={"nivel2-pdf-" + i}>
                            <small style={{paddingLeft:"5px"}}>{datos.TAMANO_PDF}
                            </small>
                          </div>
                        </>
                      :"" 
                      }
                      {
                        datos.URL_XLSZIP !==""? 
                        <>
                          <div className="col-md-1 col-xs-12" style={{marginRight:"10px"}} id={"nivel1-xslzip-" + i}>
                            <a target="_blank" href={"https://www.inegi.org.mx/contenidos/productos" + datos.URL_XLSZIP} id={"nivel2-xslzip-1-" + i}>
                              <img src="/img/ico/ico_csv.png" className="img-responsive tag-center" alt=""/>
                            </a>
                          </div>
                          <div className="col-xs-12 col-12" id={"nivel1-xslzip-" + i}>
                            <small style={{paddingLeft:"5px"}}>{datos.TAMANO_XLSZIP}
                            </small>
                          </div>
                        </>
                      :"" 
                      }
                      {
                        datos.URL_ZIP !==""? 
                        <>
                          <div className="col-md-1 col-xs-12" style={{marginRight:"10px"}} id={"nivel1-zip-" + i}>
                            <a target="_blank" href={"https://www.inegi.org.mx/contenidos/productos" + datos.URL_ZIP} id={"nivel2-zip-1-" + i}>
                              <img src="/img/ico/ico_zip.png" className="img-responsive tag-center" alt=""/>
                            </a>
                          </div>
                          <div className="col-xs-12 col-12" id={"nivel1-zip-" + i}>
                            <small style={{paddingLeft:"5px"}}>{datos.TAMANO_ZIP}
                            </small>
                          </div>
                        </>
                      :"" 
                      }
                    </div>
                  </div>
                </div>
              </div>
    
            </div>
            <div className="col-xs-12" style={{paddingLeft: "0px"}}  id={"nivel3-" + i}>
              <div className="col-xs-12 formato_fecha"  id={"nivel3-1-" + i}>
                <span className="indLink" id={"fecha_actual-" + i}> {idioma + " " + fecha(datos.FECHA_PUBLICACION)}
                </span>
              </div>
            </div> 
    
          </div>
          ))
        }
        </>
    );
  }
  else{
    let datos=parametros.datos;
    let id= parametros.id;
    let metodo= parametros.metodo;
    useEffect(() => { 
        let tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
        let tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
          return new bootstrap.Tooltip(tooltipTriggerEl)
        }) 
        if (datos.DESCRIPCION !=="")
          document.getElementById("nivel2-6-0-" + id).innerHTML=datos.DESCRIPCION;
      }, [datos]);
    return(
      <div className = "col-xs-12 col-sm-12 todo" key={"coleccionBuscadorPublicaciones-" + id} style={{marginBottom:"26px"}} id={"resultadoGeneral-" + id}>
            <div  style={{paddingLeft: "0px"}} id={"titulo-" + id}>
              <a target="_blank" href={"/app/biblioteca/ficha.html?upc=" + datos.UPC} id={"TituloHiper-0" + id}>
                <span id={"gadget-" + id} onClick={() =>registradatos(datos.TITULO, "/app/biblioteca/ficha.html?upc=" + datos.UPC, metodo)}>
                  {highlightTexto(datos.TITULO)} 
                </span>
              </a>
            </div>
            <div className="row" id={"row-" + id}>
              <div className="col-xs-12 col-md-3 col-sm-5" id={"nivel1-" + id}>
                <div className="img-prod-map" id={"nivel1-1-" + id}>
                  <a target="_blank" href={"/app/biblioteca/ficha.html?upc=" + datos.UPC} id={"snippet_row-tag-a-" + id} onClick={() =>registradatos(datos.TITULO, "/app/biblioteca/ficha.html?upc=" + datos.UPC, metodo)}>
                    <img src={"/contenidos/productos/prod_serv/contenidos/espanol/bvinegi/productos/img/" + datos.IMAGEN + ".jpg"} className="img-responsive i-sombra i-tamano" id={"imagen-" + id } alt="" />
                  </a>
                </div>
              </div>
              <div className="col-xs-12 col-md-9 col-sm-7" id={"nivel2-" + id}>
                <div id={"nivel2-0-" + id}>
                  <div className="row" id={"nivel2-0-1-" + id}>
                    <div className="col-md-3" id={"nivel2-0-1-" + id}><b> {var_ingles === "es"? "Entidad federativa:" : "Federal entity:"}</b>
                      </div>
                      <div className="col-md-6" id={"nivel2-0-2-" + id}>
                        {datos.DESC_ENTIDAD}
                    </div>
                  </div>
                  <div className="row" id={"nivel2-0-2-" + id} >
                    <div className="col-md-3" id={"nivel2-2-" + id}><b> {var_ingles === "es"? "Edición:" : "Edition:"}</b>
                      </div>
                      <div className="col-md-6" id={"nivel2-2-0-" + id}>
                        {datos.EDICION}
                    </div>
                  </div>
                  <div className="row" id={"nivel2-0-3-" + id} >
                    <div className="col-md-3" id={"nivel2-3-" + id}><b> {var_ingles === "es"? "Temporalidad:" : "Temporality:"}</b>
                      </div>
                      <div className="col-md-6" id={"nivel2-3-0-" + id}>
                        {datos.TEMPORALIDAD}
                    </div>
                  </div>
                  <div className="row" id={"nivel2-0-4-" + id} >
                    <div className="col-md-3" id={"nivel2-4-" + id}><b> {var_ingles === "es"? "Desglose geográfico:" : "Geographical breakdown:"}</b>
                      </div>
                      <div className="col-md-6" id={"nivel2-4-0-" + id}>
                        {datos.COBERTURA}
                    </div>
                  </div>
                  {
                        datos.ISBN !==""? 
                        <div className="row" id={"nivel2-0-5-" + id} >
                          <div className="col-md-3" id={"nivel2-5-" + id}><b> {"ISBN:"}</b>
                            </div>
                            <div className="col-md-9" style={{textAlign:"justify"}} id={"nivel2-5-0-" + id}>
                              {datos.ISBN}
                          </div>
                        </div>
                      :"" 
                  }
                  {
                        datos.DESCRIPCION !==""?  
                        <div className="row" id={"nivel2-0-6-" + id} >
                          <div className="col-md-3" id={"nivel2-6-" + id}><b> {var_ingles === "es"? "Descripción:" : "Description:"}</b>
                            </div>
                            <div className="col-md-8" style={{textAlign:"justify"}} id={"nivel2-6-0-" + id}>
                          </div>
                        </div>
                      :"" 
                  }
                  <div className="row" id={"nivel2-0-7-" + id} >
                    <div className="col-md-3" id={"nivel2-0-7-1-" + id}><b>{var_ingles==="es"? "Formatos" : "Formats"}</b>
                      <a className="inegi-info bbl-no-link_buscador" target="_blank" href="/inegi/ayuda/formatos/publicaciones.html" 
                      data-tooltip-id="BotonAyuda"
                      id={"snippet_row-tag_publicacion_a-" + id}
                      data-bs-toggle="tooltip"
                      data-bs-placement="bottom"
                      title={var_ingles==="es"? "Ayuda de formatos disponibles": "Help available formats"} 
                      >
                      </a>
                      <b>:</b>
                    </div>
                    <div className="col-md-6" style={{textAlign:"justify"}} id={"nivel2-0-7-2-" + id}>
                      {
                        datos.URL_PDF !==""? 
                        <>
                          <div className="col-md-1 col-xs-12" style={{marginRight:"10px"}} id={"nivel1-pdf-" + id}>
                            <a target="_blank" href={"https://www.inegi.org.mx/contenidos/productos" + datos.URL_PDF} id={"nivel1-pdf-1-" + datos.ID}>
                              <img src="/img/ico/ico_pdf.png" className="img-responsive tag-center" alt=""/>
                            </a>
                          </div>
                          <div className="col-xs-12 col-12" id={"nivel2-pdf-" + id}>
                            <small style={{paddingLeft:"5px"}}>{datos.TAMANO_PDF}
                            </small>
                          </div>
                        </>
                      :"" 
                      }
                      {
                        datos.URL_XLSZIP !==""? 
                        <>
                          <div className="col-md-1 col-xs-12" style={{marginRight:"10px"}} id={"nivel1-xslzip-" + id}>
                            <a target="_blank" href={"https://www.inegi.org.mx/contenidos/productos" + datos.URL_XLSZIP} id={"nivel2-xslzip-1-" + id}>
                              <img src="/img/ico/ico_csv.png" className="img-responsive tag-center" alt=""/>
                            </a>
                          </div>
                          <div className="col-xs-12 col-12" id={"nivel1-xslzip-" + id}>
                            <small style={{paddingLeft:"5px"}}>{datos.TAMANO_XLSZIP}
                            </small>
                          </div>
                        </>
                      :"" 
                      }
                      {
                        datos.URL_ZIP !==""? 
                        <>
                          <div className="col-md-1 col-xs-12" style={{marginRight:"10px"}} id={"nivel1-zip-" + id}>
                            <a target="_blank" href={"https://www.inegi.org.mx/contenidos/productos" + datos.URL_ZIP} id={"nivel2-zip-1-" + id}>
                              <img src="/img/ico/ico_zip.png" className="img-responsive tag-center" alt=""/>
                            </a>
                          </div>
                          <div className="col-xs-12 col-12" id={"nivel1-zip-" + id}>
                            <small style={{paddingLeft:"5px"}}>{datos.TAMANO_ZIP}
                            </small>
                          </div>
                        </>
                      :"" 
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xs-12" style={{paddingLeft: "0px"}}  id={"nivel3-" + id}>
              <div className="col-xs-12 formato_fecha"  id={"nivel3-1-" + id}>
                <span className="indLink" id={"fecha_actual-" + id}> {idioma + " " + fecha(datos.FECHA_PUBLICACION)}
                </span>
              </div>
            </div> 
    
      </div>
    );
  }
}
export default BuscadorPublicaciones;